import { AUTH_ACTION_TYPES } from './actionTypes';

const initialState = {
    token: null,
    user: null,
    isLoggedIn: false,

    otpSession: null,   // { id_session, otp_get_timeout, otp_wait_timeout }
    otpPhone: null,

    loading: {
        otp: false,
        login: false,
        signup: false,
        user: false,
    },

    error: {
        otp: null,
        login: null,
        signup: null,
        user: null,
    },
};

export const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case AUTH_ACTION_TYPES.OTP_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, otp: true },
                error: { ...state.error, otp: null },
                otpSession: null,
            };

        case AUTH_ACTION_TYPES.OTP_SUCCESS:
            return {
                ...state,
                otpSession: action.payload.otpSession,
                otpPhone: action.payload.phone,
                loading: { ...state.loading, otp: false },
                error: { ...state.error, otp: null },
            };

        case AUTH_ACTION_TYPES.OTP_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, otp: false },
                error: { ...state.error, otp: action.payload.error },
                otpSession: null,
            };

        case AUTH_ACTION_TYPES.LOGIN_OTP_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, login: true },
                error: { ...state.error, login: null },
            };

        case AUTH_ACTION_TYPES.LOGIN_OTP_SUCCESS:
            return {
                ...state,
                token: action.payload.token,
                user: action.payload.user || state.user,
                isLoggedIn: true,
                loading: { ...state.loading, login: false },
                error: { ...state.error, login: null },
                otpSession: null,
                otpPhone: null,
            };

        case AUTH_ACTION_TYPES.LOGIN_OTP_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, login: false },
                error: { ...state.error, login: action.payload.error },
            };

        case AUTH_ACTION_TYPES.SIGNUP_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, signup: true },
                error: { ...state.error, signup: null },
            };

        case AUTH_ACTION_TYPES.SIGNUP_SUCCESS:
            return {
                ...state,
                token: action.payload.token,
                user: action.payload.user || state.user,
                isLoggedIn: true,
                loading: { ...state.loading, signup: false },
                error: { ...state.error, signup: null },
            };

        case AUTH_ACTION_TYPES.SIGNUP_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, signup: false },
                error: { ...state.error, signup: action.payload.error },
            };

        case AUTH_ACTION_TYPES.FETCH_USER_REQUEST:
            return {
                ...state,
                loading: { ...state.loading, user: true },
                error: { ...state.error, user: null },
            };

        case AUTH_ACTION_TYPES.FETCH_USER_SUCCESS:
            return {
                ...state,
                user: action.payload.user,
                loading: { ...state.loading, user: false },
                error: { ...state.error, user: null },
            };

        case AUTH_ACTION_TYPES.FETCH_USER_FAILURE:
            return {
                ...state,
                loading: { ...state.loading, user: false },
                error: { ...state.error, user: action.payload.error },
            };

        case AUTH_ACTION_TYPES.LOGOUT:
            return { ...initialState };

        case AUTH_ACTION_TYPES.CLEAR_ERROR:
            return {
                ...state,
                error: { otp: null, login: null, signup: null, user: null },
            };

        default:
            return state;
    }
};
